import { Card } from "@alch/ui";
import clsx from "clsx";
import type { Control } from "react-hook-form";

import ComposerParamInput from "./ComposerParamInput/index.js";
import { buildName } from "./ComposerParamInput/lib.js";
import type { ComposerFormState } from "./lib/form.js";
import type { ComposerMethodConfig } from "./lib/methods.js";

interface ComposerParamsProps extends React.ComponentProps<typeof Card> {
  control: Control<ComposerFormState>;
  methodConfig: ComposerMethodConfig;
}

const ComposerParams = ({
  control,
  methodConfig,
  className,
  ...props
}: ComposerParamsProps) => {
  const isJsonRPCMethod =
    methodConfig.requestBody?.type === "object" &&
    methodConfig.requestBody?.properties["jsonrpc"]?.default === "2.0";
  const jsonRPCparams =
    isJsonRPCMethod && methodConfig.requestBody?.type === "object"
      ? methodConfig.requestBody.properties["params"]
      : null;
  const requestBody = isJsonRPCMethod
    ? jsonRPCparams
    : methodConfig.requestBody;

  return (
    <Card {...props} className={clsx(className, "flex flex-col gap-4 p-3")}>
      {!requestBody && !methodConfig.queryParams?.length ? (
        <span className="text-paragraph-200-regular text-secondary">
          This method has no parameters you can configure
        </span>
      ) : null}

      {methodConfig.queryParams?.map((param, index) => {
        return (
          <ComposerParamInput
            key={index}
            control={control as never}
            name={buildName("query", param.name)}
            param={param}
          />
        );
      })}

      {requestBody ? (
        <ComposerParamInput
          control={control as never}
          name={isJsonRPCMethod ? "body.params" : "body"}
          param={requestBody}
        />
      ) : null}
    </Card>
  );
};

export default ComposerParams;
